export default (value, { length }) => String(value).length < length;



// WEBPACK FOOTER //
// ./src/utils/validations/maxLengthValidator.js